import { PropertyDefinition } from './property-definition';
export class ObjectDefinition {
    constructor() {
        this.ctr = () => { };
        this.beforeDeserialized = () => { };
        this.onDeserialized = () => { };
        this.validate = undefined;
        this.properties = new Map();
        this.additionalProperties = undefined;
    }
    getProperty(key) {
        let property = this.properties.get(key);
        if (!property) {
            property = new PropertyDefinition(key.toString());
            this.properties.set(key, property);
        }
        return property;
    }
}
const objectDefinitions = new Map();
export function getDefinition(target) {
    return objectDefinitions.get(target);
}
export function hasDefinition(target) {
    return objectDefinitions.has(target);
}
export function addDefinition(target) {
    let definition = objectDefinitions.get(target);
    if (!definition) {
        definition = new ObjectDefinition();
        objectDefinitions.set(target, definition);
    }
    return definition;
}
const parentToChildDefs = new Map();
export function getChildClassDefinitions(parentType, parentDef) {
    if (parentToChildDefs.has(parentType))
        return parentToChildDefs.get(parentType);
    const childDefs = [];
    objectDefinitions.forEach((def, type) => {
        let proto = Object.getPrototypeOf(type.prototype);
        // loop thru the prototypes chain, so that a grandchild (or lower) descendent can be matched to parentType
        do {
            const superClass = proto.constructor;
            if (superClass === parentType) {
                childDefs.push([type, def]);
                break;
            }
            else {
                const superDef = objectDefinitions.get(superClass);
                if (superDef === parentDef) {
                    childDefs.push([type, def]);
                    break;
                }
            }
            proto = Object.getPrototypeOf(superClass.prototype);
        } while (proto !== null);
    });
    parentToChildDefs.set(parentType, [...childDefs]); // [...childDefs] to make a copy, since array gets changed later
    return childDefs;
}
const discriminators = new Map();
const emptyDiscriminator = new Map();
function getDiscriminator(parentType, parentDef) {
    // no discriminator property - skip
    if (!parentDef.discriminatorProperty)
        return emptyDiscriminator;
    // cached?
    const existing = discriminators.get(parentType);
    if (existing)
        return existing;
    // compute discriminator for this type and cache it
    const discriminator = new Map();
    let childDefs = getChildClassDefinitions(parentType, parentDef);
    while (childDefs.length !== 0) {
        const [t, def] = childDefs.shift(); // We are checking the length in the loop so an assertion here is fine.
        if (def.hasOwnProperty('discriminatorValue')) {
            discriminator.set(def.discriminatorValue, [t, def]);
        }
        else {
            childDefs = childDefs.concat(getChildClassDefinitions(t, def));
        }
    }
    // cache
    discriminators.set(parentType, discriminator);
    return discriminator;
}
function computeInheritanceChain(type) {
    let current = type;
    const chain = new Set();
    while (current) {
        chain.add(current.constructor);
        const parent = Object.getPrototypeOf(current);
        current = parent;
    }
    const output = Array.from(chain).filter((t) => objectDefinitions.has(t));
    return output;
}
const chains = new Map();
function getInheritanceChain(type) {
    // cached?
    const existing = chains.get(type);
    if (existing)
        return existing;
    // compute chain
    const obj = Object.create(type.prototype);
    const chain = computeInheritanceChain(obj);
    chains.set(type, chain);
    return chain;
}
export function getTypedInheritanceChain(type, object) {
    // find deepest child class
    const parentDef = objectDefinitions.get(type);
    let actualType;
    if (object && parentDef && parentDef.discriminatorProperty) {
        const discriminatorValue = object[parentDef.discriminatorProperty];
        const discriminator = getDiscriminator(type, parentDef);
        const child = discriminator.get(discriminatorValue);
        if (child) {
            const [t, def] = child;
            if (def.hasOwnProperty('discriminatorProperty')) {
                return getTypedInheritanceChain(t, object);
            }
            actualType = t;
        }
    }
    if (!actualType) {
        actualType = type;
    }
    // generate inheritance chain from deepest child class
    const inheritanceChain = getInheritanceChain(actualType);
    return inheritanceChain;
}
//# sourceMappingURL=object-definition.js.map